<template>
    <v-dialog width="760" v-model="isOpenEditDialog">
        <v-card class="mx-auto">
            <v-card-title
                class="text-h6 font-weight-regular justify-space-between"
            >
                <h3 class="font-weight-light primary--text">
                    {{ currentTitle }}
                </h3>
                <v-switch
                    v-if="step == 1"
                    inset
                    :label="editingDevice.is_active ? 'Activo' : 'Inactivo'"
                    v-model="editingDevice.is_active"
                    :color="editingDevice.is_active ? 'green' : 'red'"
                ></v-switch>
                <v-badge color="pink" :content="step" overlap>
                    <v-icon size="40">mdi-cellphone</v-icon>
                </v-badge>
            </v-card-title>

            <v-window v-model="step">
                <v-window-item :value="1">
                    <v-card class="pa-4">
                        <v-row no-gutters>
                            <v-col md="6">
                                <v-card outlined>
                                    <h4
                                        class="
                                            font-weight-light
                                            primary--text
                                            px-2
                                        "
                                    >
                                        Nombre
                                    </h4>
                                    <v-divider class="mx-2"></v-divider>
                                    <v-text-field
                                        label="name"
                                        v-model="editingDevice.name"
                                        class="pa-2"
                                    ></v-text-field>
                                </v-card>
                            </v-col>
                            <v-col md="6" class="pl-md-1">
                                <v-card outlined>
                                    <h4
                                        class="
                                            font-weight-light
                                            primary--text
                                            px-2
                                        "
                                    >
                                        Marca
                                    </h4>
                                    <v-divider class="mx-2"></v-divider>
                                    <v-text-field
                                        label="brand"
                                        v-model="editingDevice.brand"
                                        class="pa-2"
                                    ></v-text-field>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-card outlined class="pa-2 my-1">
                            <h4 class="font-weight-light primary--text">
                                Descripcion
                            </h4>
                            <v-divider></v-divider>
                            <v-textarea
                                class="px-1"
                                label="description"
                                v-model="editingDevice.description"
                            ></v-textarea>
                        </v-card>
                        <v-row no-gutters>
                            <v-col md="6">
                                <v-card outlined class="pa-2">
                                    <h4 class="font-weight-light primary--text">
                                        Precio
                                    </h4>
                                    <v-divider></v-divider>
                                    <v-text-field
                                        label="price"
                                        v-model="editingDevice.price"
                                    ></v-text-field>
                                </v-card>
                            </v-col>
                            <v-col md="6" class="pl-md-1">
                                <v-card outlined class="pa-2">
                                    <h4 class="font-weight-light primary--text">
                                        Operador
                                    </h4>
                                    <v-divider></v-divider>
                                    <v-select
                                        v-model="editingDevice.operator"
                                        :items="
                                            opciones
                                                ? opciones.tarifas.operator
                                                : []
                                        "
                                        item-text="human"
                                        item-value="encoded"
                                        label="Operador"
                                    ></v-select>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-card outlined class="pa-2 my-1">
                            <h4 class="font-weight-light primary--text ">Url en Yoigo</h4>
                            <v-divider></v-divider>
                            <v-text-field
                                label="Page_Url"
                                v-model="editingDevice.page_url"
                            ></v-text-field>
                        </v-card>
                        <v-card outlined class="px-2">
                            <h4 class="font-weight-light primary--text">Seguro</h4>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col
                                    cols="6"
                                >
                                    <v-autocomplete
                                        class="py-3"
                                        v-model="editingDevice.seguro"
                                        :items="insurances"
                                        item-text="name"
                                        return-object
                                        dense
                                        label="Activo"
                                    >
                                        <template #selection="{ item }">
                                            {{ item.is_active ? item.name : '' }}
                                        </template>
                                        <template #item="{ item }">
                                            <v-row>
                                                <v-col
                                                    cols="8"
                                                >
                                                    {{ item.name }}
                                                </v-col>
                                                <v-col
                                                    cols="2"
                                                >
                                                    {{ item.operator }}
                                                </v-col>
                                                <v-col
                                                    cols="2"
                                                >
                                                    <v-icon :color="item.is_active ? 'green' : 'red'">
                                                        mdi-circle
                                                    </v-icon>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-autocomplete
                                        multiple
                                        class="py-3"
                                        v-model="editingDevice.seguro"
                                        :items="insurances"
                                        disabled
                                        dense
                                        label="Inactivos"
                                    >
                                        <template #selection="{ item }">
                                            <v-chip v-if=" !item.is_active" small dark color="pink">{{ item.name }}</v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-card>
                </v-window-item>

                <v-window-item :value="2">
                    <v-card class="pa-4">
                        <v-row class="pb-8 px-0">
                            <v-col md="7" class="px-md-4 py-md-1">
                                <v-autocomplete
                                    clearable
                                    hide-selected
                                    :items="availableTariffs"
                                    item-text="name"
                                    v-model="search"
                                    label="Tarifa"
                                    @change="updateTariff()"
                                >
                                    <template #selection="{ item }">
                                        <v-chip
                                            small
                                            color="pink"
                                            class="white--text"
                                        >
                                            {{ item }}
                                            <v-icon right> mdi-ticket </v-icon>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col md="5" class="px-md-4 py-md-1">
                                <v-autocomplete
                                    clearable
                                    hide-selected
                                    :items="[
                                        'PREPAGO',
                                        'ALTA_NUEVA',
                                        'PORTABILIDAD',
                                        'RENUEVO',
                                    ]"
                                    v-model="searchType"
                                    label="Tipo de Installment"
                                    @change="updateTariff()"
                                >
                                    <template #selection="{ item }">
                                        <v-chip
                                            small
                                            color="green accent-3"
                                            class="black--text"
                                        >
                                            {{ item }}
                                            <v-icon right color="black">
                                                mdi-format-list-bulleted-type
                                            </v-icon>
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-data-table
                            dense
                            :headers="headers"
                            :items="searchInstallments"
                            class="elevation-0"
                            :footer-props="footer_props"
                        >
                            <template v-slot:item.is_active="{ item }">
                                <v-icon
                                    :color="item.is_active ? 'green' : 'red'"
                                >
                                    mdi-circle
                                </v-icon>
                            </template>
                            <template v-slot:item.Actions="{ item }">
                                <v-col v-if="hasSuperAdminPermission" md="12">
                                    <div
                                        class="
                                            d-flex
                                            flex-row
                                            justify-space-between
                                        "
                                    >
                                        <v-btn
                                            fab
                                            x-small
                                            color="orange"
                                            outlined
                                            @click="openInstallmentForm(item)"
                                        >
                                            <v-icon> mdi-pen </v-icon>
                                        </v-btn>
                                        <v-btn
                                            class="ml-md-1"
                                            fab
                                            x-small
                                            color="red"
                                            outlined
                                            @click="deleteInstallment(item)"
                                        >
                                            <v-icon> mdi-delete </v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-window-item>

                <v-window-item :value="3">
                    <div class="pa-4 text-center">
                        <v-img
                            class="mb-4"
                            contain
                            height="300"
                            :src="
                                editingDevice &&
                                editingDevice.devices &&
                                editingDevice.devices[0]
                                    ? editingDevice.devices[0].images[0].url
                                    : ''
                            "
                        ></v-img>
                        <h2 class="text-h6 font-weight-light mb-2">
                            {{ editingDevice.name }}
                        </h2>
                        <h3 class="text-h6 font-weight-light mb-2">
                            {{ editingDevice.price + ' €' }}
                        </h3>
                    </div>
                </v-window-item>
            </v-window>

            <v-divider></v-divider>

            <v-card-actions>
                <v-btn :disabled="step === 1" v-if="formType == 'EDIT'" text @click="step--">Atrás</v-btn>
                <v-btn
                    v-if="step != 3 && formType == 'EDIT'"
                    :disabled="step === 3 || loadingInstallments"
                    color="primary"
                    :loading="loadingInstallments"
                    depressed
                    @click="step++"
                    >{{
                        step == 1 ? 'Installments' : step == 2 ? 'Imagen' : ''
                    }}</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn text color="red" @click="isOpenEditDialog = false">
                    Cerrar
                </v-btn>
                <v-btn
                    v-if="step == 1 && formType == 'EDIT'"
                    color="success"
                    depressed
                    @click="updateDevice()"
                    >Actualizar</v-btn
                ></v-btn>
                <v-btn
                    v-if="step == 1 && formType == 'CREATE'"
                    color="success"
                    depressed
                    @click="createDevice()"
                    >Crear</v-btn
                ></v-btn>
                <v-tooltip v-if="step == 2" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            depressed
                            v-if="step == 2"
                            @click="openAddingForm()"
                            color="green"
                            dark
                            v-bind="attrs"
                            v-on="on"
                        >
                            Crear Installment
                        </v-btn>
                    </template>
                    <div class="d-flex flex-column">
                        <span>Recuerda que es recomendable al crear un </span>
                        <span
                            >nuevo precio por tarifa desactivar el
                            anterior!!</span
                        >
                    </div>
                </v-tooltip>
            </v-card-actions>
        </v-card>
        <InstallmentForm />
    </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import defaultInstallmentForm from '@/util/management/defaultInstallmentForm.js';
import { clone } from '@/util/libUtil.js';
import InstallmentForm from '@/components/ComercialTeletrabajo/DeviceManagement/InstallmentForm.vue';

export default {
    data: () => ({
        insurance_filtered: [],
        confirmDeleteDialog: false,
        searchInstallments: [],
        availableTariffs: [],
        searchType: null,
        search: null,
        step: 1,
        headers: [
            {
                text: 'Tarifa',
                value: 'tariff_name',
                width: '200px',
            },
            { text: 'Tipo', value: 'installment_type' },
            { text: 'Precio Mensual', value: 'month_price' },
            { text: 'Precio Inicial', value: 'initial_price' },
            { text: 'Precio Final', value: 'final_price' },
            {
                text: 'Activo',
                value: 'is_active',
                width: '10px',
            },
            {
                text: ' ',
                value: 'Actions',
                sortable: false,
                width: '10px',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [8],
        },
    }),
    components: {
        InstallmentForm,
    },
    computed: {
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        currentTitle() {
            switch (this.step) {
                case 1:
                    return this.formType != 'CREATE'
                        ? 'Datos Básicos de ' + this.editingDevice?.name
                        : 'Creando un Dispositivo';
                case 2:
                    return 'Precios por Tarifa';
                default:
                    return 'Dispositivo';
            }
        },
        editingDevice: {
            get() {
                return this.$store.state.deviceManagement.deviceEdit.form;
            },
            set(val) {
                this.$store.commit('deviceManagement/editingDevice', val);
            },
        },
        isOpenEditDialog: {
            get() {
                let isOpen = this.$store.state.deviceManagement.deviceEdit.isOpenEditDialog
                
                if(isOpen && this.formType == 'EDIT'){
                    this.step=1
                }
                
                return isOpen;
            },
            set(val) {
                this.$store.commit('deviceManagement/isOpenEditDialog', val);
            },
        },
        ...mapState('deviceManagement', {
            installment: (state) => state.installment,
            insurances: (state) => state.insurances,
            formType: (state) => state.deviceEdit.formType,
            loadingInstallments: (state) => state.loadingInstallments,
        }),
        // ...mapState('util', {
        //     opciones: (state) => state.opciones,
        // }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    methods: {
        deleteInstallment(item) {
            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: 'INSTALLMENT',
                isOpenDeleteDialog: true,
            };

            this.$store.commit(
                'deviceManagement/deleteObject',
                clone(deleteObj)
            );
        },
        openAddingForm() {
            let installmentObj = clone(defaultInstallmentForm);

            installmentObj['terminal__name'] = this.editingDevice?.name;
            installmentObj['terminal__id'] = this.editingDevice?.id;
            installmentObj['is_active'] = true;
            installmentObj['created_on'] = new Date();
            installmentObj['updated_on'] = new Date();

            this.$store.commit(
                'deviceManagement/editingInstallment',
                clone(installmentObj)
            );
            this.$store.commit(
                'deviceManagement/installmentFormType',
                'CREATE'
            );
            this.$store.commit(
                'deviceManagement/isOpenEditInstallmentDialog',
                true
            );
        },
        openInstallmentForm(item) {
            let installmentObj = clone(defaultInstallmentForm);
            installmentObj['terminal__id'] = this.editingDevice?.id;

            for (let key in installmentObj) {
                if (key in item) {
                    installmentObj[key] = item[key];
                }
            }

            this.$store.commit(
                'deviceManagement/editingInstallment',
                clone(installmentObj)
            );
            this.$store.commit('deviceManagement/installmentFormType', 'EDIT');
            this.$store.commit(
                'deviceManagement/isOpenEditInstallmentDialog',
                true
            );
        },
        stripString(val) {
            if (typeof val !== 'string') return '';
            return val
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s/g, '');
        },
        updateTariff() {
            if (this.search != '' || this.searchType != '') {
                this.searchInstallments = this.installment.filter((item) => {
                    let filter_tariff =
                        this.search == 'Único'
                            ? item.tariff == null
                            : this.stripString(item.tariff_name).includes(
                                  this.stripString(this.search)
                              );
                    let filter_type = this.searchType
                        ? item.installment_type == this.searchType
                        : true;

                    return filter_tariff && filter_type;
                });
            } else this.searchInstallments = this.installment;
        },
        ...mapActions('deviceManagement', ['updateDevice', 'createDevice']),
    },
    watch :{
        editingDevice(){
            // this.changeSeguroSwitch()
        },
        installment(){
            this.availableTariffs = this.installment.map((installment) =>{
                return installment.tariff_name ? installment.tariff_name : 'Único'
            });

            this.searchInstallments = this.installment;
        },
    },
};
</script>








